<template>
  <div class="guide-entry">
    <i class="iconfont icon-info"></i>
    <p class="entry-text">寺库优惠券<router-link class="entry-link" to="/v1/ucticketList/operatingGuide">使用指南</router-link></p>
  </div>
</template>

<script>
  export default {
    name: 'guide-entry'
  }
</script>

<style lang="scss" scoped>
.guide-entry {
  height: toRem(37);
  line-height: toRem(37);
  font-size: toRem(26);
  margin-bottom: toRem(31);
  font-size: 0;
  .icon-info {
    display: inline-block;
    margin-right: toRem(12);
    width: toRem(28);
    height: toRem(28);
    font-size: toRem(28);
    color: #F8A120;
  }
  .entry-text {
    display: inline-block;
    font-size: toRem(26);
  }
  .entry-link {
    text-decoration: underline;
    color: #F8A120;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/TicketList/components/GuideEntry.vue